import React, { useEffect, useState } from "react";
import { Col, Tabs, Row } from "antd";
import WorkFlow from '../../components/workflowcomponent/workflow';
import WorkflowMetaData from "./WorkflowMetaData";
import WorkflowComponent from './WorkflowComponent';
import SearchMetaDataResult from './SearchMetaDataResult';

const { TabPane } = Tabs;
const WorkflowTab = ({ wfId, wfCatId, wfName }) => {

    return (

        <div>

            <Row>
                <Col span={24}>
                    <Tabs defaultActiveKey="1">
                        <TabPane tab="Workflow" key="1">
                            <WorkFlow wfId={wfId} wfCatId={wfCatId} />
                        </TabPane>
                        <TabPane tab="Metadata" key="2">
                            <WorkflowMetaData wfId={wfId} />
                        </TabPane>
                        <TabPane tab="Messages" key="3">
                            <WorkflowComponent wfId={wfId} />
                        </TabPane>
                        <TabPane tab="Data Search" key="4">
                            <SearchMetaDataResult wfId={wfId} />
                        </TabPane>
                    </Tabs>
                </Col>
            </Row>
        </div>
    );
};

export default WorkflowTab;